import React, {Component} from "react";
import {connect} from "react-redux";
import {reduxForm} from "redux-form";
import { validate as isValidEmail } from "email-validator";
import submitVerifyEmail from "../actions/submitVerifyEmail";


const form = "verify-email";
const fields = ["emailAddress"];
const errorColor = "rgb(217, 83, 79)";

export const validate = (values, props) =>
    !isValidEmail(values.emailAddress) ? {emailAddress: "Invalid email address"} : {};

export const VerifyEmail = (props) => {
    let emailInputStyle = props.fields.emailAddress.touched && props.fields.emailAddress.error ? {borderColor: errorColor} : {};

    let emailForm = <div style={{padding: ".5em"}}>
        <div style={{padding: ".5em"}}>We need to verify your email address so we can show you your disclosures.</div>
        <form className="pure-g pure-form pure-u-1" style={{ fontSize: "120%" }} onSubmit={props.handleSubmit(submitVerifyEmail)}>
            <input className="pure-u-1" style={emailInputStyle} placeholder="Email address" {...props.fields.emailAddress}/>
            {props.fields.emailAddress.touched && props.fields.emailAddress.error
                                               && <div className="x-error" style={{color: errorColor}}>{props.fields.emailAddress.error}</div>}
            <button type="submit" className="pure-button pure-u-1 pure-button-primary">Verify</button>
        </form>
    </div>;

    let emailSubmittedMessage = <div style={{padding: ".5em"}}>
        <div style={{padding: ".5em"}}>Thank you!</div>
        <div style={{padding: "1em .5em .5em"}}>We've sent an email to <a href={"mailto:" + props.fields.emailAddress.value}>{props.fields.emailAddress.value}</a>.</div>
        <div style={{padding: ".5em"}}>Please click the link in that message to access your disclosures.</div>
        <div style={{padding: "1.5em 0.5em .5em"}}>If you have any trouble viewing disclosures please use the support button below.</div>
    </div>;

    return (
        <div>
            <h1 style={{ color: "#28313E", fontWeight: "bold", margin: 0, padding: 10, fontSize: "1em", borderBottom: "1px solid #ddd", backgroundColor: "#eee"}}>
                View your disclosures
            </h1>
            { props.submitting ? emailSubmittedMessage : emailForm }
        </div>
    );
};

export default reduxForm({form, fields, validate})(VerifyEmail);



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/portal/components/VerifyEmail.js
 **/